import React from 'react';
import './Logo.css';

function Logo({ size = 'default', className = '' }) {
  return (
    <div className={'logo-wrap logo-wrap--' + size + ' ' + (className || '').trim()}>
      <h1 className="logo-wordmark">
        <span className="logo-clarity">Clarity</span>
        <span className="logo-two">2</span>
        <span className="logo-work">Work</span>
      </h1>
      <svg
        className="logo-underline"
        width="100%"
        height="8"
        viewBox="0 0 380 8"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M0,4 Q95,0 190,4 T380,4"
          stroke="var(--accent-link)"
          strokeWidth="3"
          fill="none"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}

export default Logo;
